import { Component, model, ChangeDetectionStrategy } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'

@Component({
  selector: 'lib-full-text-search',
  imports: [FormsModule, MatFormFieldModule, MatInputModule, MatIconModule],
  templateUrl: './full-text-search.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './full-text-search.component.scss',
})
export class FullTextSearchComponent {
  text = model<string>()
}
